import React from "react";

const trimText = (text, length, end = "") => {
  if (!text) return;
  return text.length <= length ? text : `${text.substr(0, length)}${end}`;
};

const getFileFormat = str => {
  if (!str) return;
  return str.split("/")[1].toUpperCase();
};

const cutExt = str => {
  if (!str) return;
  return str.replace(/\.[^/.]+$/, "");
};

export {
  trimText,
}
